import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

// Local assets
import tabLineBgImg from '@/assets/images/reward-page/tab-line-bg.svg';

export const WelcomeRewardsSection = styled.section`
  position: relative;
  width: 100%;
  background: #f6f7fa;
  padding: 52px 0;
  min-height: 820px;
`;

export const SectionContainer = styled.div`
  position: relative;
  width: 1170px;
  margin-left: 375px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 39px;
  box-sizing: border-box;

  @media (max-width: 1600px) {
    margin-left: auto;
    margin-right: auto;
    max-width: calc(100% - 40px);
  }

  @media ${media.mobile} {
    width: 100%;
    margin-left: 0;
    padding: 0 20px;
  }
`;

export const TabMenu = styled.div`
  position: relative;
  width: 100%;
  height: 33px;
`;

export const TabItem = styled.div<{ $active: boolean }>`
  display: inline-block;
  font-family: 'Rubik', sans-serif;
  font-size: 20px;
  line-height: 24px;
  color: ${(props) => (props.$active ? '#181b54' : 'rgba(24, 27, 84, 0.6)')};
  font-weight: ${(props) => (props.$active ? 500 : 400)};
  margin-right: 31px;
  cursor: pointer;
`;

export const TabLine = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-image: url(${tabLineBgImg});
  background-size: contain;
  background-repeat: no-repeat;
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
`;

export const RocketIcon = styled.div`
  width: 37.822px;
  height: 48.616px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(14.414deg);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const TitleText = styled.h2`
  font-family: 'Rubik', sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: normal;
  color: #181b54;
  margin: 0;
`;

export const HighlightText = styled.span`
  color: #60b7c7;
`;

export const CardsGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px 19px;
  align-items: flex-start;
  width: 100%;
  justify-content: flex-start;

  @media ${media.mobile} {
    flex-direction: column;
  }
`;

export const RewardCard = styled.div<{ $hasBadge?: boolean }>`
  position: relative;
  border: 1.5px solid rgba(43, 47, 115, 0.3);
  border-radius: 12px;
  background: #ffffff;
  padding: 34px 25px 34px 30px;
  display: flex;
  gap: 30px;
  align-items: center;
  width: 575px;
  min-width: 575px;
  max-width: 575px;
  height: 244px;
  flex-shrink: 0;
  box-sizing: border-box;

  @media ${media.mobile} {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
`;

export const LimitedBadge = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #e2e4fe;
  padding: 5px 18px;
  border-radius: 11.5px 0 4px 0;
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #181b54;
  z-index: 2;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RewardAmountBox = styled.div`
  position: relative;
  width: 149px;
  height: 174.144px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const AmountImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const AmountContent = styled.div<{ $isCredit?: boolean; $isGalaxy?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.$isCredit ? 'flex-start' : 'center')};
  gap: ${(props) => (props.$isCredit ? '1px' : '8px')};
  position: ${(props) => (props.$isGalaxy ? 'absolute' : 'relative')};
  z-index: 1;
  padding-top: ${(props) => (props.$isCredit ? '36px' : props.$isGalaxy ? '35px' : '38px')};
  padding-bottom: ${(props) => (props.$isCredit ? '0' : '35px')};
  padding-left: ${(props) => (props.$isCredit ? '17px' : props.$isGalaxy ? '28px' : '26px')};
  padding-right: ${(props) => (props.$isCredit ? '17px' : props.$isGalaxy ? '28px' : '26px')};
  width: ${(props) => (props.$isCredit ? '74px' : props.$isGalaxy ? '54px' : '54px')};
  ${(props) => props.$isGalaxy && `
    left: 50%;
    transform: translateX(-50%);
    top: 0;
  `}
`;

export const AmountValue = styled.div<{ $isCredit?: boolean; $isGalaxy?: boolean }>`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: ${(props) => (props.$isCredit ? '24px' : '40px')};
  line-height: 30px;
  color: #ffffff;
  text-shadow: 0px -1.5px 1px rgba(146, 95, 57, 0.15);
  text-align: ${(props) => (props.$isCredit ? 'left' : 'center')};
  width: 100%;
  ${(props) => props.$isGalaxy && `
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
  `}
`;

export const AmountUnit = styled.div<{ $isCredit?: boolean; $isGalaxy?: boolean }>`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: ${(props) => (props.$isCredit ? '24px' : '20px')};
  line-height: 30px;
  color: #ffffff;
  text-shadow: ${(props) => (props.$isCredit ? 'none' : '0px -1.5px 1px rgba(146, 95, 57, 0.15)')};
  text-align: ${(props) => (props.$isCredit ? 'left' : 'center')};
  width: 100%;
  ${(props) => props.$isGalaxy && `
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 38px;
  `}
`;

export const AmountLabel = styled.div`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: #ffffff;
  text-shadow: 0px -1.5px 1px rgba(146, 95, 57, 0.15);
  margin-top: 18px;
  text-align: center;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 322px;
  flex-shrink: 0;
`;

export const MissionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const MissionType = styled.div`
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #60b7c7;
`;

export const MissionTitle = styled.div`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: normal;
  color: #181b54;
`;

export const MissionDescription = styled.p`
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(24, 27, 84, 0.6);
  margin: 0;
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

export const ProgressText = styled.div`
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #181b54;
`;

export const ProgressValue = styled.span`
  color: #60b7c7;
`;

export const ProgressBar = styled.div`
  position: relative;
  width: 171px;
  height: 0;
`;

export const ProgressBarBg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 168px;
  height: auto;
`;

export const ProgressBarFill = styled.img<{ $progress: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => Math.min(props.$progress * 168, 168)}px;
  height: auto;
`;

export const GiftIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const DiamondIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ClaimButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 11px 26px;
  border-radius: 30px;
  background: #60b7c7;
  border: none;
  color: #ffffff;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const TradeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 29px;
  border-radius: 30px;
  background: #60b7c7;
  border: none;
  color: #ffffff;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const ClaimedButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 29px;
  border-radius: 30px;
  background: #474747;
  border: none;
  color: #b5b5bc;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: not-allowed;
`;

// Legacy styles for backward compatibility
export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SummaryItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 226px;
  justify-content: space-between;

  border-radius: 8px;
  background-color: ${({ theme }) => theme.COLORS.tableBg};
  padding: 36px;

  @media ${media.desktop} {
    min-height: 0;
    padding: 24px;
  }
`;

export const SummaryItemTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
`;

export const SummaryItemContentWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media ${media.mobile} {
    grid-template-columns: repeat(1, 1fr);
    gap: 32px;
  }
`;

export const SummaryItemContent = styled.div<{ isDarkmode: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: ${({ isDarkmode }) =>
    isDarkmode
      ? '0px 0px 23px -5px rgba(255, 255, 255, 0.15)'
      : '0px 0px 23px -5px rgba(0, 0, 0, 0.075)'};
`;

export const SummaryDesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
`;

export const SummaryItemDes = styled.div`
  color: ${({ theme }) => theme.COLORS.greenText};
  font-size: 16px;
  line-height: 1.25;
  font-weight: 400;
`;

export const SummaryItemSubDes = styled.div`
  position: absolute;
  color: ${({ theme }) => theme.COLORS.itemContent};
  font-size: 14px;
  font-weight: 400;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
`;

export const SummaryItemName = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;

  font-size: 32px;
  font-weight: 600;
  height: 32px;

  @media ${media.mobile} {
    font-size: 24px;
  }
`;

export const SummaryItemButton = styled.button`
  border: 1px solid #ff5c17;
  border-radius: 4px;
  width: 100%;
  height: 54px;
  color: #ff5c17;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif !important;

  @media ${media.desktop} {
    height: 42px;
    font-size: 14px;
  }
`;

export const tetherImg = styled.img`
  width: 32px;
  height: 32px;
  position: relative;

  @media ${media.mobile} {
    width: 24px;
    height: 24px;
  }
`;

export const ClaimedRewardButton = styled.button`
  margin-top: 6px;
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  background: #9e9e9e;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
`;

export const RewardButton = styled.button`
  margin-top: 6px;
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  background: #0dcb81;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;

  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ExternalTabButton = styled.button<{ isDarkmode: boolean }>`
  padding: 8px 14px;
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ isDarkmode }) => (isDarkmode ? '#3A3B3F' : '#C2D3CC')};
  border-top: none;
  border-radius: 0px 0px 10px 10px;
  background: ${({ isDarkmode }) => (isDarkmode ? '#232425' : '#D3E6DF')};
  color: ${({ theme }) => theme.COLORS.greenText};
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 0;
  clip-path: polygon(0 0, 100% 0, calc(100% - 12px) 100%, 12px 100%);

  span {
    display: inline-block;
    font-weight: 700;
    font-size: 14px;
  }
`;

export const DisabledRewardButton = styled.button`
  margin-top: 6px;
  width: 100%;
  padding: 10px;
  border: 1px solid #ff5c17;
  background: transparent;
  color: #ff5c17;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Pretendard';
  cursor: pointer;

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const DescriptionContainer = styled.div<{ isDarkmode: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 24px;
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 8px;

  @media ${media.mobile} {
    margin-top: 16px;
    padding: 16px 20px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

export const DescriptionContent = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.sectionDesc};
  line-height: 1.8;
  text-align: left;
  white-space: pre-line;
  opacity: 0.8;
  flex: 1;

  @media ${media.mobile} {
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
  }
`;
